module.exports = __webpack_public_path__ + "img/logo.e47c71f2.png";